module.exports = __webpack_public_path__ + "img/golog_smarttruck.7f79066e.png";